import { reconnect } from '@wagmi/core'
import { wagmiConfig } from 'lib/wagmiConfig'
import { useEffect } from 'react'

const useEagerConnect = () => {
  useEffect(() => {
    void reconnect(wagmiConfig).catch(() => {
      /* No restored session — user connects manually */
    })
  }, [])
}

export default useEagerConnect
